import { createSelector } from 'reselect';

import RootState from 'Store/Root';

import { PrintScaleOption } from 'Types/Basket';

export type BasicItemOptions = {
  brands: TrykApi.Catalog.ISiteBrand[];
  printScales: PrintScaleOption[];
};

export const basicOptionsSelector = createSelector(
  (state: RootState) => state.site.item.brands,
  (state: RootState) => state.printScales.items,
  (brands, printScales): BasicItemOptions => ({
    brands,
    printScales
  })
);
